import React from 'react';

/**
 * FAQ Schema Markup Generator
 * Generates JSON-LD structured data for FAQ pages
 */

export interface FAQItem {
  question: string;
  answer: string;
}

export function generateFAQSchema(faqs: FAQItem[]) {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return schema;
}

/**
 * Generate FAQ JSON-LD script tag
 */
export function FAQSchemaScript({ faqs }: { faqs: FAQItem[] }) {
  const schema = generateFAQSchema(faqs);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
